import { useContext } from 'react'
import { Container, Wrap } from './LoadingSpinner.styles'
import { StoreContext } from '@/components/App'

interface LoadingSpinnerProps {
  centered?: boolean
}

export const LoadingSpinner = ({ centered }: LoadingSpinnerProps) => {
  const store = useContext(StoreContext)
  const { theme } = store.AppState

  return (
    <Wrap $centered={centered}>
      <Container id="loading" {...theme.loadingSpinner}></Container>
    </Wrap>
  )
}
